import React from 'react';
import { motion } from 'framer-motion';

interface UserProgressProps {
  userName: string;
  points: number;
  level: number;
  pointsToNextLevel: number;
  color: string;
  selectedShape: 'circle' | 'triangle' | 'square';
}

export const UserProgress: React.FC<UserProgressProps> = ({
  userName,
  points,
  level,
  pointsToNextLevel,
  color,
  selectedShape
}) => {
  const shapeStyles = {
    circle: "rounded-full",
    triangle: "clip-path-triangle",
    square: "transform rotate-15"
  };

  return (
    <div className="space-y-4 font-['SF_Pro_Display']">
      <div className="relative">
        <div className="flex items-start justify-between">
          <div className="flex-grow pr-[140px]">
            <motion.h1 
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-[165px] tracking-[-0.08em] text-[#292B2D] leading-[0.85] max-md:text-8xl max-sm:text-6xl inline-flex flex-wrap"
            >
              <span className="whitespace-nowrap h-[140px]">Hi,&nbsp;</span>
              <span className="break-all">{userName}</span>
            </motion.h1>
          </div>
          <div
            className={`absolute top-0 right-0 shrink-0 ${shapeStyles[selectedShape]}`}
            style={{ 
              height: '140px',
              width: '140px',
              backgroundColor: color
            }}
          />
        </div>
      </div>

      <div className="flex gap-1 text-5xl font-light tracking-tighter max-md:text-4xl">
        <div className="flex-1 basis-0 min-w-[240px]">
          <div className="text-[#292B2D]">
            You Have
            <br />
            <span className="font-semibold">{points} Points</span>
          </div>
        </div>

        <div className="flex-1 basis-0 min-w-[240px]">
          <div className="text-[#292B2D]">
            You Are On
            <br />
            <span className="font-semibold">Level {level}</span>
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <p className="font-bold text-3xl" style={{ color }}>
          {pointsToNextLevel} POINTS NEEDED TO LEVEL UP!
        </p>
        <div className="relative h-[22px] rounded-[500px] overflow-hidden" style={{ backgroundColor: `${color}33` }}>
          <motion.div 
            className="absolute top-0 left-0 h-full rounded-[500px]"
            style={{ backgroundColor: color }}
            initial={{ width: 0 }}
            animate={{ width: `${points}%` }}
            transition={{ duration: 1, ease: "easeOut" }}
          />
        </div>
      </div>
    </div>
  );
};